import { runWithLogger } from "@dailywars/core/log";
import { createMiddleware } from "@tanstack/react-start";
import type { AuditableLogger } from "evlog";
import { useRequest } from "nitro/context";

import { runInRequestGameContextStore } from "#/server/game/requestGameContextStore.server";

export const requestContextMiddleware = createMiddleware({ type: "request" }).server(({ next }) => {
  const requestLog = useRequest().context?.log as AuditableLogger | undefined;

  const run = () => runInRequestGameContextStore(() => next());

  if (!requestLog) {
    return run();
  }

  return runWithLogger(requestLog, run);
});
